// Company research files live in the fingerprint-synthesis repo under a
// folder named after the company (lowercased), e.g. `optos/playbook.md`.
export const FINGERPRINT_SYNTHESIS_BASE_URL =
  'https://github.com/medscout-gtm/fingerprint-synthesis/blob/main';
export const PLAYBOOK_FILE_NAME = 'playbook.md';
export const PROFILE_CONFIGS_FILE_NAME = 'profile-configs.md';
